export default __webpack_public_path__ + "static/media/CQ_feuille_jeu_mars_2022.e19a4e20.pdf";